export default __webpack_public_path__ + "static/media/screen_livechat_19.24432f9b.png";